import { Select } from 'antd';
import type { SelectProps } from 'antd/es/select';
import React, { useEffect, useState } from 'react';
import { apiQueryContractList } from 'api/mall';
import { IAgreement } from './types/search';
import { debounce } from 'lodash';

let fetchCount = 0;
let errorCount = 0;
let loading = false;
let hasMore = false;
let pageNo = 1;
const ContractSelect: React.FC<
  Omit<SelectProps<string>, 'options' | 'children' | 'onDropdownVisibleChange'>
> = (props) => {
  const { selectAreas } = props;
  const [options, setOptions] = useState<Array<IAgreement>>([]);

  const loadOptions = async (first = false, name = '') => {
    try {
      loading = true;
      let currentCount = null;
      fetchCount += 1;
      currentCount = fetchCount;

      if (first) {
        pageNo = 1;
      }
      else {
        pageNo += 1
      }
      const { data } = await apiQueryContractList({
        json: {
          selectAreas,
          pageNo,
          pageSize: 20,
          name: name,
        },
      });
      if (!data.datas) return;
      if (currentCount !== fetchCount) return;
      const list = first ? data.datas : [...options, ...data.datas]
      setOptions(list);
      hasMore = list?.length < data.total
    } catch (error) {
      errorCount += 1
    }
    loading = false;
  };
  const onSearch = debounce((str) => {
    loadOptions(true, str)
  }, 700);
  const onPopupScroll = (e: any) => {
    if (errorCount >= 3) return;
    if (e.target.scrollTop + e.target.offsetHeight + 100 >= e.target.scrollHeight) {
      if (hasMore && !loading) {
        loadOptions()
      }
    }
  };
  useEffect(() => {
    loadOptions(true, '');
  }, [selectAreas]);
  const stop = (e) => {
    e.preventDefault();
  };
  const focus = () => {
    document.body.addEventListener('touchmove', stop, {
      passive: false,
    });
  };
  const blur = () => {
    document.body.removeEventListener('touchmove', stop, {
      passive: false,
    });
  };

  return (
    <Select
      bordered={false}
      style={{ width: '100%' }}
      showSearch
      placeholder="请输入合同名称"
      onBlur={blur}
      onDropdownVisibleChange={(open) => (open ? focus() : blur())}
      {...props}
      filterOption={false}
      size="small"
      onSearch={onSearch}
      onPopupScroll={onPopupScroll}
    >
      {options.map((item, i) => (
        <Select.Option value={item.sysNo} key={`${i}---${item.contractName}`}>
          <div>
            <div>{item.contractName}</div>
          </div>
        </Select.Option>
      ))}
    </Select>
  );
};

export default ContractSelect;
